import axios from 'axios';

const service = axios.create({
  baseURL: '/toAISearch',
  timeout: 120000
})
//请求头 token 封装
service.defaults.headers.post['Content-Type'] = 'application/json';

service.interceptors.request.use(
  config => {

    return config;


  },
  error => {
    return Promise.reject(error)
  }
);
// http response l拦截器
service.interceptors.response.use(
  response => {

    return response
  }
)
//get
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params
    }).then(response => {

      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}


//post
export function postkimi(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        resolve({
          summary: err
        });
      })
  })
}



export default service
